/* =========================================================================
   WWC CRO-concept - materiaalkiezer: gedrag na een wissel

   WAT HIER NIET MEER STAAT
   Dit bestand haalde eerder de prijzen van alle uitvoeringen op met acht losse
   fetches naar /products/{handle}.js, en schreef ze daarna in de DOM. Dat was
   onnodig: snippets/wwc-woodtype-bubbles.liquid loopt al door de producten van
   de stadscollectie en heeft `p.price` dus gewoon in handen.

   Prijzen, bandbreedte en aantal staan nu in Liquid. Scheelt acht verzoeken per
   paginaweergave, ze staan meteen in beeld in plaats van na een idle-callback,
   en zoekmachines lezen ze mee.

   WAT ER WÉL OVERBLIJFT
   Het gedrag na een materiaalwissel. Elke uitvoering is een eigen product-URL,
   dus een volledige herlading - en dan moet de bezoeker wel op de juiste plek
   uitkomen. Dat kan Liquid niet weten, want het hangt af van waar hij vandaan
   kwam.

   NAAR BOVEN, PANEEL DICHT
   Je wisselt van houtsoort om het HOUT te zien. Sinds de galerij compact is
   passen foto, titel, prijs en kiezer samen in het eerste scherm, dus bovenaan
   beginnen laat allebei zien. Een eerdere versie zette je terug op de kiezer
   (dan staat de foto boven je scherm) en klapte het paneel open (dan land je op
   een muur van uitvoeringen in plaats van op het product dat je net koos).
   ========================================================================= */

(function () {
  'use strict';

  var picker = document.querySelector('.wwc-material-picker');
  if (!picker) return;

  var SWITCH_KEY = 'wwcCroMatSwitched';

  /* --- Aankomst na een materiaalwissel ----------------------------------- */
  try {
    if (sessionStorage.getItem(SWITCH_KEY)) {
      sessionStorage.removeItem(SWITCH_KEY);

      window.requestAnimationFrame(function () {
        window.scrollTo({ top: 0, behavior: 'auto' });

        // Kort oplichten, zodat duidelijk is dat de keuze is overgenomen.
        var chosen = picker.querySelector('.wwc-material-picker__chosen');
        if (chosen && chosen.animate) {
          chosen.animate(
            [{ opacity: 1 }, { opacity: .35 }, { opacity: 1 }],
            { duration: 900, iterations: 1 }
          );
        }
      });
    }
  } catch (e) { /* privatemodus: dan gewoon bovenaan beginnen */ }

  picker.addEventListener('click', function (ev) {
    if (!ev.target.closest || !ev.target.closest('.wwc-material-option')) return;
    try { sessionStorage.setItem(SWITCH_KEY, '1'); } catch (e) {}
  }, { passive: true });
})();

/* =========================================================================
   VORMKIEZER: hetzelfde aankomstgedrag als de materiaalkiezer

   De twee kiezers zien er bewust identiek uit (zie de CSS-kop bij .wwc-vorm),
   maar deden na de klik iets anders: materiaal scrollde naar boven en liet de
   nieuwe keuze kort oplichten, vorm deed niets. Dezelfde belofte, andere
   afloop - en dat is precies het soort verschil dat een pagina onrustig maakt
   zonder dat je kunt aanwijzen waarom.

   Eigen sleutel, zodat een materiaalwissel en een vormwissel elkaar niet in de
   weg zitten wanneer iemand ze snel achter elkaar doet.
   ========================================================================= */
(function () {
  'use strict';

  var VORM_KEY = 'wwcCroVormSwitched';

  /* Aankomst: de vlag staat in sessionStorage OF in de URL. Die tweede route
     is er voor wie de link deelt of in een nieuw tabblad opent - dan is er geen
     sessionStorage van de vorige pagina. */
  var viaUrl = /[?&]vormgewisseld=1/.test(location.search);
  var viaOpslag = false;
  try { viaOpslag = !!sessionStorage.getItem(VORM_KEY); } catch (e) {}

  if (viaUrl || viaOpslag) {
    try { sessionStorage.removeItem(VORM_KEY); } catch (e) {}

    if (viaUrl) {
      /* Vlag uit de URL halen: anders blijft hij bij vernieuwen opnieuw vuren
         en staat hij in een gedeelde link. */
      var u = new URL(location.href);
      u.searchParams.delete('vormgewisseld');
      history.replaceState(null, '', u.toString());
    }

    window.requestAnimationFrame(function () {
      window.scrollTo({ top: 0, behavior: 'auto' });
      var nu = document.querySelector('.wwc-vorm__optie.is-nu');
      if (!nu) return;
      nu.classList.add('wwc-vorm-bevestig');
      window.setTimeout(function () { nu.classList.remove('wwc-vorm-bevestig'); }, 1500);
    });
  }

  /* Vertrek: vlag zetten zodat de volgende pagina weet dat er gewisseld is. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a.wwc-vorm__optie');
    if (!link) return;
    try { sessionStorage.setItem(VORM_KEY, '1'); } catch (e2) {}
    /* RICHTING, want daar begon deze meting om.
       Hier stond alleen vorm_naar, en "Rond" zegt niets over op of af: bij de
       klok is rond duurder, bij de plank nauwelijks, en bij steden met gelijke
       prijzen is er geen verschil. Zonder cent_van/cent_naar is de op-af-
       verhouding niet af te lezen - het enige dat dit event moest opleveren.
       De bedragen staan sinds vandaag als data-attribuut op de link
       (snippets/wwc-vorm.liquid). */
    if (window.dataLayer) {
      var centVan = parseInt(link.getAttribute('data-cent-van'), 10);
      var centNaar = parseInt(link.getAttribute('data-cent-naar'), 10);
      var geldig = !isNaN(centVan) && !isNaN(centNaar);
      window.dataLayer.push({
        event: 'wwc_vorm_switch',
        soort: link.getAttribute('data-soort') || null,
        vorm_van: link.getAttribute('data-vorm-van') || null,
        vorm_naar: link.getAttribute('data-vorm-naar') ||
                   ((link.querySelector('strong') || {}).textContent || '').trim(),
        cent_van: geldig ? centVan : null,
        cent_naar: geldig ? centNaar : null,
        richting: geldig ? (centNaar > centVan ? 'op' : (centNaar < centVan ? 'af' : 'gelijk')) : null
      });
    }
  }, true);
})();
